var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 592,
    height: 592,
    viewBox: "0 0 592 592",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_443_49)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 512,
    transform: "matrix(1 0 0 -1 488 552)",
    fill: "#330036"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 512,
    transform: "matrix(1 0 0 -1 424 552)",
    fill: "#6369D1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 512,
    transform: "matrix(1 0 0 -1 360 552)",
    fill: "#0892A5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 512,
    transform: "matrix(1 0 0 -1 296 552)",
    fill: "#75B9BE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 512,
    transform: "matrix(1 0 0 -1 232 552)",
    fill: "#9BC53D"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 512,
    transform: "matrix(1 0 0 -1 168 552)",
    fill: "#FFAE03"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 512,
    transform: "matrix(1 0 0 -1 104 552)",
    fill: "#E28413"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 512,
    transform: "matrix(1 0 0 -1 40 552)",
    fill: "#F45B69"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 552,
    height: 552,
    rx: 276,
    stroke: "black",
    strokeWidth: 40
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_443_49"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 512,
    height: 512,
    rx: 256,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.16b24ad53c8fa70254768f5b15f32d30.svg";
export { ForwardRef as ReactComponent };